import { useCallback } from 'react';
import { withRouter } from 'react-router-dom';

import { DefaultSheet } from 'twyne-new.ui';

import history from 'utils/history';

import { useDashboardStore } from '../../../store'
import Form from '../components/Form';
import { UserProfileProvider, useUserProfileStore } from '../store';

const UserProfileForm = withRouter(({ match: { params: { id } } }) => {
  const { collection: { item, useLoad, useSubmit, deleteEntry, reset } } = useUserProfileStore()
  const { list } = useDashboardStore()

  useLoad(id)

  const handleSubmit = useSubmit()

  const handleClose = useCallback(async () => {
    reset()
    history.push('/path/dashboard')
    await list()
  }, [reset, list])

  const handleSubmitAndRedirect = useCallback(async payload => {
    await handleSubmit(payload)
    handleClose()
  }, [handleSubmit, handleClose])

  const handleRemoveProfile = () => {
    deleteEntry(item)
    handleClose()
  }

  if (!item) {
    return null
  }

  return <DefaultSheet
    title={item.id ? 'Edit User Profile' : 'Add User Profile'}
    trigger={<></>}
    wrapperProps={{ defaultOpen: true, onOpenChange: open => !open && handleClose() }}
  >
    <Form
      data={item || {}}
      onSubmit={handleSubmitAndRedirect}
      profileActive={true}
      onRemoveProfile={handleRemoveProfile}
    />
  </DefaultSheet>
})

export default function UserProfileFormLayout() {
  return <UserProfileProvider>
    <UserProfileForm />
  </UserProfileProvider>
}
